import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6267b271"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-msg-box-root" }
const _hoisted_2 = { class: "message-msg-box-wrap" }
const _hoisted_3 = { class: "message-msgbox-title-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "修改密码", -1))
const _hoisted_5 = { class: "message-body-wrap" }
const _hoisted_6 = { class: "form" }
const _hoisted_7 = { class: "item-field" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "item-field" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "item-field" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "item-field error" }
const _hoisted_14 = { class: "message-body-button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "password",
              placeholder: _ctx.t('oldpwd'),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.oldPass) = $event))
            }, null, 8, _hoisted_8), [
              [_vModelText, _ctx.oldPass]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "password",
              placeholder: _ctx.t('newpwd'),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPass) = $event))
            }, null, 8, _hoisted_10), [
              [_vModelText, _ctx.newPass]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              type: "password",
              placeholder: _ctx.t('confirmpwd'),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmPass) = $event))
            }, null, 8, _hoisted_12), [
              [_vModelText, _ctx.confirmPass]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.message), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          class: "btn-cancel btn",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, "取消"),
        _createElementVNode("div", {
          class: "btn-confirm btn",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
        }, "确定")
      ])
    ])
  ]))
}